import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';
import { DepositTransactionImpactTypesEnum } from '../document-data.data';

export const DEPOSIT_TRANSACTION_SCHEMA = Object.freeze({
  DEPOSIT_ID: '',
  TRANSACTION_ID: '',
  AMOUNT_FOR_DEPOSIT: 0,
  TIMESTAMP: '', // i2g-datetime
  IMPACT_TYPE: null, // DepositTransactionImpactTypesEnum
});
export const RECORD = generateSchema(DEPOSIT_TRANSACTION_SCHEMA);
export const KEYS: any = generateKeys(DEPOSIT_TRANSACTION_SCHEMA);

export class DepositTransaction extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get depositId(): string {
    return this.get(KEYS.DEPOSIT_ID);
  }

  get transactionId(): string {
    return this.get(KEYS.TRANSACTION_ID);
  }

  get timestamp(): string {
    return this.get(KEYS.TIMESTAMP);
  }

  get amountForDeposit(): number {
    return this.get(KEYS.AMOUNT_FOR_DEPOSIT);
  }

  get impactType(): DepositTransactionImpactTypesEnum {
    return this.get(KEYS.IMPACT_TYPE);
  }
}
